import { render, staticRenderFns } from "./cardBaseStation.vue?vue&type=template&id=112aa6c6&scoped=true&"
import script from "./cardBaseStation.vue?vue&type=script&lang=js&"
export * from "./cardBaseStation.vue?vue&type=script&lang=js&"
import style0 from "./cardBaseStation.vue?vue&type=style&index=0&id=112aa6c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112aa6c6",
  null
  
)

export default component.exports